import { jsx as _jsx } from "react/jsx-runtime";
import { Code as HeroCode } from '@heroui/react';
export const Code = (props) => {
    return _jsx(HeroCode, { ...props });
};
export default Code;
//# sourceMappingURL=Code.js.map